import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MatTableDataSource } from '@angular/material/table';
import { AutoUnsubscribe } from '../decorators/auto-unsubscribe.decorator';
import { Subscription } from 'rxjs';

@Directive({
    selector: '[noDataTableMessage]',
    standalone: false
})
@AutoUnsubscribe
export class NoDataTableMessageDirective<T> implements OnInit {
  @Input() text = 'common.list.noData';

  @Input() set dataSource(data: MatTableDataSource<T> | T[]) {
    const message = this.element.parentElement?.querySelector('.no-data-message');
    const text = this.translateService.instant(this.text);
    const template = `<p class="no-data-message">${text}</p>`;
    const dataSource = data instanceof Array ? data : data?.data;

    if (!dataSource) {
      return;
    }

    if (!dataSource.length && !message) {
      this.element.insertAdjacentHTML('afterend', template);
    }

    if (dataSource.length && message) {
      message?.remove();
    }
  }

  subscriptions: Subscription[] = [];

  private element = this.elementRef.nativeElement;

  constructor(private elementRef: ElementRef, private translateService: TranslateService) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.translateService.onLangChange.subscribe(() => {
        const noDataMessage = this.element.parentElement.querySelector('.no-data-message');

        if (noDataMessage) {
          noDataMessage.innerText = this.translateService.instant(this.text);
        }
      }),
    );
  }
}
